// Mirrors the host requirement enforced server-side by
// Boom::Models::HasCustomButtonLink#custom_button_link_valid?, so an
// otherwise well-formed but host-less URL (e.g. "https://") is caught here
// instead of round-tripping to a 400.
export const validateCustomButtonLink = (value: string): string | undefined => {
  if (!value) return undefined;

  try {
    const url = new URL(value);
    if ((url.protocol === "http:" || url.protocol === "https:") && url.hostname)
      return undefined;
  } catch {
    // fall through to the shared error below
  }

  return "Enter a valid URL";
};
